<template>
  <div>
    <h1>Dashboard</h1>
    <p>Welcome to the dynamic dashboard!</p>

    <!-- Dynamic content example -->
    

    <!-- Static Table -->
    <h2>Statistics Overview</h2>
    <table class="dashboard-table">
      <thead>
        <tr>
          <th>Metric</th>
          <th>Value</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Total Revenue</td>
          <td>$10,000</td>
        </tr>
        <tr>
          <td>Active Users</td>
          <td>500</td>
        </tr>
        <tr>
          <td>New Sign-ups</td>
          <td>75</td>
        </tr>
        <tr>
          <td>Support Tickets</td>
          <td>20</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'DashboardPage',
};
</script>

<style scoped>
/* Optional dashboard-specific styles */

.dashboard-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}

.dashboard-table th,
.dashboard-table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}

.dashboard-table th {
  background-color: #f2f2f2;
  font-weight: bold;
}

.dashboard-table tr:nth-child(even) {
  background-color: #f9f9f9;
}

.dashboard-table tr:hover {
  background-color: #eaeaea;
}
</style>
